import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useUrlQueryParams from "../../hooks/useUrlQeryParams";
import useGetAllData from "../../hooks/useGetAllData";
import SearchInput from "../../components/search_input";
import { Button, Select, SelectProps } from "antd";
import { CiSearch } from "react-icons/ci";
import { IoClose, IoFileTraySharp } from "react-icons/io5";
import PDFIcon from '../../assets/images/pdf_icon.png'
import { VscFilePdf } from "react-icons/vsc";
import { FaFileDownload } from "react-icons/fa";
import { ICountries } from "../../models/countries";
import { ISpecialization } from "../../models/spetsialization";
import { IRegions } from "../../models/regions";
import { IArbitratorLanguages } from "../../models/arbitrator_languages";
import { IArbitratorAreas } from "../../models/arbitrator_areas";
import { IArbitratorTags } from "../../models/arbitrator_tags";

const ArbitralOrders: React.FC = () => {
  const { t } = useTranslation()
  const [searchVal, setSearchVal] = useState<string>("");
  const [countrySearchVal, setcountrySearchVal] = useState<string>("");
  const [specializationSearchVal, setspecializationSearchVal] = useState<string>("");
  const [regionSearchVal, setregionSearchVal] = useState<string>("");
  const [languagesSearchVal, setlanguagesSearchVal] = useState<string>("");
  const [arbitratorareaSearchVal, setarbitratorareaSearchVal] = useState<string>("");
  const [tagSearchVal, settagSearchVal] = useState<string>("");
  const [alldata, setallData] = useState([])
  const country_options: SelectProps['options'] = [];
  const specializations_options: SelectProps['options'] = [];
  const regions_options: SelectProps['options'] = [];
  const arbitrator_options: SelectProps['options'] = [];
  const arbitratorarea_options: SelectProps['options'] = [];
  const tag_options: SelectProps['options'] = [];

  const { urlValue, writeToUrl } = useUrlQueryParams({
    currentPage: 1,
    perPage: 10,
  });

  const { data: countries, } = useGetAllData<ICountries[]>({
    queryKey: ["countries"],
    url: "countries",
  });

  const { data: specializations, } = useGetAllData<ISpecialization[]>({
    queryKey: ["specializations"],
    url: "specializations",
  });

  const { data: regions, } = useGetAllData<IRegions[]>({
    queryKey: ["regions"],
    url: "regions",
  });

  const { data: arbitrator_languages, } = useGetAllData<IArbitratorLanguages[]>({
    queryKey: ["arbitrator_languages"],
    url: "arbitrator_languages",
  });

  const { data: arbitrator_area, } = useGetAllData<IArbitratorAreas[]>({
    queryKey: ["arbitrator_areas"],
    url: "arbitrator_areas",
  });

  const { data: tags, } = useGetAllData<IArbitratorTags[]>({
    queryKey: ["tags"],
    url: "tags",
  });

  const { data: arbitrators } = useGetAllData<any>({
    queryKey: ["arbitrators", urlValue.perPage, urlValue.currentPage, searchVal, countrySearchVal, specializationSearchVal, regionSearchVal, languagesSearchVal, arbitratorareaSearchVal, tagSearchVal],
    url: "arbitrators",
    urlParams: { "perPage": urlValue.perPage, page: urlValue.currentPage, 'person.lastName': searchVal, counrty: countrySearchVal, arbitratorSpecialization: specializationSearchVal, region: regionSearchVal, arbitratorLanguages: languagesSearchVal, area: arbitratorareaSearchVal, tag: tagSearchVal },
    options: {
      refetchOnWindowFocus: false,
      retry: 1,
      onSuccess: (res: any) => {
        setallData(res);
      },
    },
  });

  countries?.map((item: any) => {
    country_options?.push({ label: item?.name, value: item?.id })
  })

  specializations?.map((item: any) => {
    specializations_options?.push({ label: item?.name, value: item?.id })
  })

  regions?.map((item: any) => {
    regions_options?.push({ label: item?.name, value: item?.id })
  })

  arbitrator_languages?.map((item: any) => {
    arbitrator_options?.push({ label: item?.name, value: item?.id })
  })

  arbitrator_area?.map((item: any) => {
    arbitratorarea_options?.push({ label: item?.name, value: item?.id })
  })

  tags?.map((item: any) => {
    tag_options?.push({ label: item?.name, value: item?.id })
  })


  const handleChange = (value: string[]) => {
    writeToUrl({ name: "countries", value: `${value}` })
    setcountrySearchVal(`${value}`)
  };

  const handlespecializationChange = (value: string[]) => {
    writeToUrl({ name: "specialization", value: `${value}` })
    setspecializationSearchVal(`${value}`)
  };

  const handleregionsChange = (value: string[]) => {
    writeToUrl({ name: "regions", value: `${value}` })
    setregionSearchVal(`${value}`)
  };

  const handlelanguagesChange = (value: string[]) => {
    writeToUrl({ name: "languages", value: `${value}` })
    setlanguagesSearchVal(`${value}`)
  };

  const handlearbitratorareaChange = (value: string[]) => {
    writeToUrl({ name: "arbitrator-area", value: `${value}` })
    setarbitratorareaSearchVal(`${value}`)
  };

  const handletagsChange = (value: string[]) => {
    writeToUrl({ name: "arbitrator-area", value: `${value}` })
    settagSearchVal(`${value}`)
  };


  return (
    <>
      <div className='py-10'>
        <div className="grid grid-cols-11 gap-4">
          <div className="col-span-11">
            <SearchInput duration={500} setSearchVal={setSearchVal} placeholder={`${t('Search by name ...')}`} />
          </div>
          <div className="col-span-3 max-sm:col-span-11 border-r-2 pr-4">
            <div className='mb-3'>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%', height: '44px' }}
                placeholder={t('Select tags')}
                onChange={handletagsChange}
                options={tag_options}
              />
            </div>
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%', height: '44px' }}
              placeholder={t('Select country')}
              onChange={handleChange}
              options={country_options}
            />
          </div>
          <div className="col-span-3 max-sm:col-span-11 border-r-2 pr-4">
            <div className='mb-3'>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%', height: '44px' }}
                placeholder={t('Select arbitrator area')}
                onChange={handlearbitratorareaChange}
                options={arbitratorarea_options}
              />
            </div>
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%', height: '44px' }}
              placeholder={t('Select specialization')}
              onChange={handlespecializationChange}
              options={specializations_options}
            />
          </div>
          <div className="col-span-3 max-sm:col-span-11 border-r-2 pr-4">
            <div className='mb-3'>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%', height: '44px' }}
                placeholder={t('Select languages')}
                onChange={handlelanguagesChange}
                options={arbitrator_options}
              />
            </div>
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%', height: '44px' }}
              placeholder={t('Select regions')}
              onChange={handleregionsChange}
              options={regions_options}
            />
          </div>
          <div className='col-span-2 max-sm:col-span-11'>
            <Button htmlType='button' className='rounded-xl text-white text-center h-[44px] justify-center flex items-center bg-main_color w-full mb-3'><CiSearch size={24} color='white' className='mr-4' />{t('Search')}</Button>
            <Button htmlType='button' className='rounded-xl text-center h-[44px] justify-center flex items-center w-full border-1 border-main_color'><IoClose size={24} color='#29487E' className='mr-4' />{t('Close')}</Button>
          </div>
        </div>

        <hr className='h-[3px] mt-12 bg-[#DAE8F0] rounded' />

        <div className='mt-6'>

          <div className='grid grid-cols-12 gap-4 mt-8'>
            {
              arbitrators?.length ? arbitrators?.map((item: any) => (
                <div className="col-span-12 rounded border border-solid border-[#29487E] p-3 hover:shadow-lg hover:shadow-[#A2C4D9] bg-[#F7F7F7]">
                  <div className="flex justify-between">
                    <div className="w-[140px] h-[130px] rounded bg-[#A9D1E9] pt-8 mr-3">
                      <img src={PDFIcon} alt="pdf icon" className="mx-auto w-[54px] h-[60px] block" />
                    </div>
                    <div className="w-[85%]">
                      <div className="flex justify-between">
                        <h2 className="text-[18px] font-semibold">Arbitral Award for case PI5251-23</h2>
                        <div className="flex items-center">
                          <a href="" download className="rounded-xl text-white text-center bg-main_color p-2 mr-4">
                            <VscFilePdf size={20} color="white" />
                          </a>
                          <a href="" download className="rounded-xl text-white text-center bg-main_color p-2">
                            <FaFileDownload size={20} color="white" />
                          </a>
                        </div>
                      </div>
                      <p>
                        A dispute from a forwarding contract for areight transportation organization.
                      </p>
                      <div className="flex justify-between rounded-xl bg-white items-center py-2 px-3 mt-3">
                        <span>Arbitrator: <span className="text-main_color font-semibold">{item?.person?.lastName} {item?.person?.firstName}</span></span>
                        <span>Country: <span className="text-main_color font-semibold">Poligova Elena</span></span>
                        <span>Language: <span className="text-main_color font-semibold">Poligova Elena</span></span>
                        <span>Exprince: <span className="text-main_color font-semibold">Poligova Elena</span></span>
                      </div>
                    </div>
                  </div>
                </div>
              )) : <div className="col-span-12 justify-center text-center"><IoFileTraySharp size={100} color="#F0F0F0" className="block mx-auto"/><span className="text-[#dadada] font-bold text-2xl ">{t('No data')}</span></div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default ArbitralOrders